// src/contexts/NavContext.js
// Navigazione Contestuale Intelligente — context globale
// Permette a qualsiasi componente di aprire una scheda entità con openEntity(type, data)

import React, { createContext, useContext, useState, useCallback } from "react";

const NavContext = createContext(null);

export function NavProvider({ children, onNavigate }) {
  const [drawer, setDrawer] = useState(null);
  // drawer = { type: "cliente"|"commessa"|"dipendente"|"task", data: {...}, stack: [...] }

  // Apre una entità nel drawer. Se già aperto, aggiunge allo stack (navigazione breadcrumb)
  const openEntity = useCallback((type, data) => {
    setDrawer(prev => {
      const stack = prev ? [...(prev.stack || []), { type: prev.type, data: prev.data }] : [];
      return { type, data, stack };
    });
  }, []);

  // Torna all'entità precedente nello stack
  const goBack = useCallback(() => {
    setDrawer(prev => {
      if (!prev || !prev.stack || prev.stack.length === 0) return null;
      const stack = [...prev.stack];
      const last = stack.pop();
      return { type: last.type, data: last.data, stack };
    });
  }, []);

  // Chiude il drawer completamente
  const closeDrawer = useCallback(() => setDrawer(null), []);

  // Naviga a una pagina piena (commessa → apre ProjectView)
  const navigateFull = useCallback((nav) => {
    setDrawer(null);
    if (onNavigate) onNavigate(nav);
  }, [onNavigate]);

  return (
    <NavContext.Provider value={{ drawer, openEntity, goBack, closeDrawer, navigateFull }}>
      {children}
    </NavContext.Provider>
  );
}

// Funzioni no-op usate come fallback quando useNav è chiamato fuori dal provider
const noopNav = {
  drawer: null,
  openEntity: () => {},
  goBack: () => {},
  closeDrawer: () => {},
  navigateFull: () => {},
};

export function useNav() {
  const ctx = useContext(NavContext);
  // Ritorna no-op invece di crashare se fuori dal provider
  // (es. componenti renderizzati durante SSR o test)
  return ctx || noopNav;
}
